import React from 'react'
import REASONS from './constants'
import ReasonsToBelieveBanner from '../ReasonsToBelieveBanner'

const WhyPricelineBanner = () => {
  return <ReasonsToBelieveBanner content={REASONS} />
}

export default WhyPricelineBanner
